import { Environment } from './environment.model';

export const environment: Environment = {
  productionMode: true,
  googleTagManagerId: 'GTM-T7G2NMS2',
  prismicEndpoint: 'https://chmobile-support.cdn.prismic.io/api/v2',
  brand: 'chmobile',
  fallbackLang: 'de',
  newMicroServiceEndpoint: 'https://prod.ms.api.chmobile.ch',
  websiteUrl: 'https://www.chmobile.ch',
  checkoutUrl: 'https://checkout.chmobile.ch',
  allowedMsEnvs: [],
  defaultUrlsEnvironment: '',
  featureFlagClientKey: 'sdk-1AyWzT53SObto3SV',
  selfcareUrl: 'https://my.chmobile.ch',
  sprinklerAppId: '66c60bb29bfd097343b32b8c_app_444',
};
